import { LawsuitInfo } from "@customTypes/responses/lawsuit";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import React from "react";
import { Button } from "nectar-ui";
import { useInfiniteQuery } from "react-query";
import { HistoricalListContainer } from "../components/style";
import HistoricalsStateManagement from "../components/HistoricalStateManagement/HistoricalStateManagement";
import { ListCard, NormalText } from "@components/styles/dataDisplay";
import { EmptyState } from "@components/EmptyState";
import { EmptyStateDocuments } from "@components/svgs";
import { fetchLawsuitHistoricals } from "@services/lawsuit";
import { MoreButtonContainer } from "@pages/LawsuitListPage/style";

type CaseMovementsTab = {
  lawsuit: LawsuitInfo;
};
const CaseMovementsTab: React.FC<CaseMovementsTab> = ({ lawsuit }) => {
  const {
    data,
    isSuccess,
    isLoading,
    hasNextPage, 
    fetchNextPage
  } = useInfiniteQuery({
    queryKey: ["fetchLawsuitHistoricals", lawsuit.id],
    queryFn: ({pageParam = ""}) => fetchLawsuitHistoricals({ lawsuitId: lawsuit.id, cursor: pageParam }),
    keepPreviousData: true,
    getNextPageParam: (lastPage) => {
      return lastPage.cursor === "" ? undefined : lastPage.cursor;
    },
  });

  const handleFetchMore = () => {
    fetchNextPage();
  };

  const historicalCurrentCount = data?.pages.reduce((acc, page) => {
    return acc + page.historicals.length;
  }, 0);

  const isEmpty = historicalCurrentCount < 1;

  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin size="sm">
            Andamentos
          </CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            Veja todos os andamentos do seu caso em ordem cronológica.
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      {isEmpty ? (
        <EmptyState title="Este caso ainda não possui andamentos" icon={<EmptyStateDocuments />}>
          <NormalText noMargin>
            Quando houver registros de andamentos, eles aparecerão aqui.
          </NormalText>
        </EmptyState>
      ) : (
        <React.Fragment>
          <ListCard noDivider border>
            <HistoricalListContainer>
              <HistoricalsStateManagement
                isLoading={isLoading}
                isSuccess={isSuccess}
                data={data}
              />
                {hasNextPage && (
                  <MoreButtonContainer>
                    <Button onClick={handleFetchMore} color="primary" reverse>
                      carregar mais andamentos
                    </Button>
                  </MoreButtonContainer>
                )}
            </HistoricalListContainer>
          </ListCard>
        </React.Fragment>
      )}
    </div>
  );
};

export default CaseMovementsTab;
